import { openBlockageEnTranslations } from './open-blockage.en';
import { openBlockageHeTranslations } from './open-blockage.he';

export const openBlockageTranslations = {
  en: openBlockageEnTranslations,
  he: openBlockageHeTranslations,
} as const;
